var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51838 10.6429C6.79867 10.6429 7.83656 9.60352 7.83656 8.32143C7.83656 7.03934 6.79867 6 5.51838 6C4.23808 6 3.2002 7.03934 3.2002 8.32143C3.2002 9.60352 4.23808 10.6429 5.51838 10.6429Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5184 10.6429C18.7987 10.6429 19.8366 9.60352 19.8366 8.32143C19.8366 7.03934 18.7987 6 17.5184 6C16.2381 6 15.2002 7.03934 15.2002 8.32143C15.2002 9.60352 16.2381 10.6429 17.5184 10.6429Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8822 15.2861C17.8822 17.3375 15.1145 19.0004 11.7004 19.0004C8.28625 19.0004 5.51855 17.3375 5.51855 15.2861",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWinkWhite);
export default __webpack_public_path__ + "static/media/ic_wink_white.a1a8f906134dc3ffd454cad6f4c37493.svg";
export { ForwardRef as ReactComponent };